import {$axios} from "../../helper";
import {ServerClippngP} from "../../../lib/constants/server";

export type TEmailQuestionParams = {
    title: string,
    content: string,
    email:string
}
export type TEmailQuestion = {
    token: string
} & TEmailQuestionParams
/** 联系我们发邮件
 * @see http://doc.bigbigwork.com/docs/hw/8071
 */
export default function EmailQuestion (
    params:TEmailQuestion
) {
    return $axios ({
        url: `${ServerClippngP}/email/userQuestion`,
        method: "GET",
        headers: {
            token: params.token
        },
        params: {
            email: params.email,
            title: params.title,
            content: params.content
        }
    })
}
